<template>
  <common-page-edit
    :title="title"
    :nameRoleEntity="nameRoleEntity"
    :apiNameGet="apiNameGet"
    :apiNameCreate="apiNameCreate"
    :apiNameUpdate="apiNameUpdate"
    routeNameShow="CounterpartyBankDetailsShow"
    routeNameCreate="CounterpartyBankDetailsEdit"
    :keyRoute="'CompanyId'"
    :backUrl="pathBack"
    @set-loadData="setLoadData"
    :convertLoadData="convertLoadData"
    :paramsSave="paramsSave"
    :isDefaultConverter="false"
    :paramsSend="paramsSend"
    :forceNoShowEdit="true"
    :showHistory="true"
    :apiNameGetHistory="apiNameGetHistory"
    :keyRouteHistory="keyRouteHistory"
  >
    <!-- <template v-slot:block2>
        <company-data
          :isCreditCard="true"
          :loadDataIn="loadData"
          v-if="loadData"
          :activeShowMenu="true">
        </company-data>
    </template> -->
  </common-page-edit>
</template>
<script>
import { API_METHODS, FIELD_LANG_COMPANY } from "../../../../constant";
import { NAME_OBJECT } from "../../../../RoleConstanans";
import CommonPageEdit from "../../commonElement/CommonPageEdit.vue";
import CompanyData from "../company/CompanyData.vue";

import convertFieldInfoListToScheme from "../../../../helpers/converters/convetFieldInfoListToScheme";

export default {
  name: "ClientEditPageDynamic",
  components: {
    CommonPageEdit,
    CompanyData
  },
  data() {
    return {
      apiNameGetHistory: API_METHODS.GET_HISTORY_COUNTERPARTY_BANK_DETAILS,
      keyRouteHistory: "CompanyId",
      wait: false,
      scheme: {},
      loadData: null,
      fieldInfoList: null,
      preResult: null,
      load: true,

      routeNameShow: "CbdShow",
      routeNameCreate: "CbdCreate",

      pathBack: "/crm/CounterpartyBankDetails",
      apiNameGet: API_METHODS.GET_COUNTERPARTY_BANK_DETAILS,
      apiNameCreate: API_METHODS.CREATE_COUNTERPARTY_BANK_DETAILS,
      apiNameUpdate: API_METHODS.UPDATE_COUNTERPARTY_BANK_DETAILS,
      loadData: null
    };
  },
  computed: {
    title() {
      let text1 = this.$t("Просмотр реквизитов");
      let text2 = this.$t("Создание реквизитов");
      let text3 = this.$t("Редактирование реквизитов");

      let findShow = this.$route.path.indexOf("show");
      if (findShow != -1) {
        return text1;
      }
      let findCreate = this.$route.path.indexOf("create");
      if (findCreate != -1) {
        return text2;
      }
      let findEdit = this.$route.path.indexOf("edit");
      if (findEdit != -1) {
        return text3;
      }
      return text1;
    },
    nameRoleEntity() {
      return NAME_OBJECT.clients;
    },
    paramsSend() {
      return {
        id: this.$route.params.CompanyId || "0",
        typeCompany: "Client"
      };
    }
  },

  methods: {
    convertLoadData(res) {
      let loadData = res.object;
      let fieldInfoList = res.fieldInfoList;
      let scheme = { configForm: [] };

      scheme.configForm = convertFieldInfoListToScheme({
        fieldInfoList,
        langFieldName: FIELD_LANG_COMPANY
      });

      return {
        loadData,
        fieldInfoList,
        scheme
      };
    },
    setLoadData(loadData) {
      this.loadData = loadData;
    },

    paramsSave() {
      return {
        id: this.$route.params.CompanyId,
      };
    }
  }
};
</script>
